import { h } from '@/lib/dom';

type ToastType = 'success' | 'error' | 'info';

interface ToastOptions {
  type?: ToastType;
  duration?: number;
  action?: { label: string; onClick: () => void };
}

let root: HTMLElement | null = null;

function ensureRoot(): HTMLElement {
  if (!root) {
    root = document.getElementById('toast-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'toast-root';
      document.body.appendChild(root);
    }
  }
  return root;
}

export function toast(message: string, options: ToastOptions = {}): void {
  const { type = 'info', duration = 4000, action } = options;
  const el = h('div', {
    class: `toast ${type}`,
    role: type === 'error' ? 'alert' : 'status',
  }, [
    h('div', { class: 'toast-message', style: 'flex: 1;' }, message),
    action
      ? h(
          'button',
          {
            class: 'btn btn-sm btn-ghost',
            on: {
              click: () => {
                action.onClick();
                el.remove();
              },
            },
          },
          action.label,
        )
      : null,
  ]);
  ensureRoot().appendChild(el);
  const remove = () => {
    if (el.isConnected) el.remove();
  };
  if (duration > 0) setTimeout(remove, duration);
}
